import React, { useEffect } from "react";
import Footer from "../components/Footer";
import img1 from "../assets/Contactless1.jpg";
import img2 from "../assets/samrt energy_dashboard_01.png";

const SmartEnergyMonitoringSystem = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <div className="container py-5 main-content" style={{ marginTop: "50px" }}>
        <h1>Smart Energy Monitoring Devices</h1>

        <p className="lead">
          <strong>Problem Statement</strong><br />

          Telecom sites and industrial facilities waste huge amounts of energy because ACs run continuously at fixed settings.
          There is no intelligent temperature-based control, no remote visibility, and no automation — leading to higher electricity
          bills, overheating risks, and increased carbon emissions.
        </p>

        <p className="lead">
          <strong>VionsTech Solution</strong><br />
          Our Smart Energy Monitoring System automatically controls the AC based on the site’s real-time temperature,
          ensuring cooling only when needed. It optimizes energy usage, prevents over-cooling, and provides full remote
          monitoring — reducing power consumption, lowering operational cost, and cutting carbon footprint without
          compromising performance.
        </p>

        <div className="row my-4">

          <div className="col-md-12 mb-5 d-flex justify-content-center">
            <div className="img-card h-100 d-flex align-items-center justify-content-center">
              <img
                src={img2}
                alt="Smart Energy Dashboard"
                className="img-fluid rounded shadow"
                style={{ maxHeight: "400px", objectFit: "contain" }}
              />
            </div>
          </div>
        </div>
        <style>{`
            
            .img-card:hover {
                box-shadow: 0 8px 32px rgba(25, 118, 210, 0.15);
                transform: translateY(-4px) scale(1.02);
            }
        `}</style>
      </div>

      <Footer />
    </div>
  );
};

export default SmartEnergyMonitoringSystem;
